import { AutenticacionService, ModulosARK, TipoPermiso } from './../../services/autenticacion.service';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ReportesService } from './../../services/reportes.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReporteLiquidacionService } from '../../services/reporte-liquidacion.service';
import {ObrasService} from "../../services/obras.service";
import { ReporteBalanceKRService } from '../../services/reporte-balance-kr.service';
import { DetallesBalanceKRModalComponent } from './detalles-balance-kr-modal/detalles-balance-kr-modal.component';

@Component({
  selector: 'app-reporte-balance-kr',
  templateUrl: './reporte-balance-kr.component.html',
  styleUrls: ['./reporte-balance-kr.component.scss']
})
export class ReporteBalanceKRComponent implements OnInit {
  @ViewChild(DetallesBalanceKRModalComponent) detallesKRModal: DetallesBalanceKRModalComponent;
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;
  public reportes_lista: any[] = [];
  public reporte_actual: any;
  public fecha_actual: any;
  public fecha_inicial_filter: any;
  public fecha_final_filter: any;
  public fecha_creacion: any;
  public fechas_reporte_selected: any = {};
  public totales_reporte_selected: any = {};
  public top_ingresos: any[] = [];
  public top_egresos: any[] = [];
  public top_ingresos_max: any;
  public top_egresos_max: any;
  public movimientos: any[] = [];
  public concepto_filter: any;
  public concepto_options: any[];
  public securityActived: any = false;
  public loading_report: any = true;
  public show_report: any = false;
  public not_report: any = false;
  public printing: boolean = false;
  public report_request: any;
  constructor(private obrasService: ObrasService,
              private reportesService: ReportesService,
              private reporteBalanceKR: ReporteBalanceKRService,
              private reporteLiquidacionService: ReporteLiquidacionService, 
              private helperService: HelpersService,
              private router: Router,
              private activedRoute: ActivatedRoute, 
              private helpersService: HelpersService,
              private sanitizer: DomSanitizer, 
              private authService: AutenticacionService) {
  }

  ngOnInit() {
    this.start();
  }

  getLiquidaciones(){
    
  }

  start() {
    let reportes_lista = this.reportesService.getListaReportes();
    for (let i = 0; i < reportes_lista.length; i++) {  
      if(reportes_lista[i]["id"] == 1 && this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 2 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 3 && this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 4 && this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
        this.reporte_actual = reportes_lista[i]; // reporte balance kr
      }
      if(reportes_lista[i]["id"] == 5 && this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 6 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 7 && this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 8 && this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 9 && this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
    }

    this.getFechaActual();
    this.getConceptos();
  }

  changeReporte(reporte) {
    if (reporte.id && reporte.id != this.reporte_actual.id) {
      this.router.navigate([reporte.ruta]);
    }
  }

  return() {
    this.router.navigate(['/catalogo-reportes']);
  }

  getFechaActual() {
    this.reportesService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fecha_actual = content.fecha;
          this.fecha_inicial_filter = content.fechaInicio;
          this.changeFilterFechaFinal(this.fecha_actual);
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
          this.loading_report = false;
          this.show_report = false;
          this.not_report = true;
          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }

  getConceptos() {
    this.reporteBalanceKR.getConceptos()
      .subscribe(response => {
        const content_response = response.json().content;
        this.concepto_options = content_response;
      }, error => {
        this.helperService.httpGlobalError(error);
      });
  }

  getReporte() {
    this.loading_report = true;
    this.show_report = false;
    if (this.report_request) {
      this.report_request.unsubscribe();
    }
    this.report_request = this.reporteBalanceKR.getReporte(this.concepto_filter, this.fecha_inicial_filter, this.fecha_final_filter)
      .subscribe(response => {
        const content_response = response.json().content;
        this.fechas_reporte_selected = content_response.fechas;
        this.totales_reporte_selected = content_response.informacion;
        this.fecha_creacion = content_response.fechaCreacion;
        this.top_ingresos = content_response.topIngresos;
        this.top_egresos = content_response.topEgresos;
        this.movimientos = content_response.movimientos;
        if (this.top_ingresos.length > 0) {
          this.top_ingresos_max = this.top_ingresos[0].importe;
          console.log('new top ingreso max ', this.top_ingresos_max);
        }
        if (this.top_egresos.length > 0) {
          this.top_egresos_max = this.top_egresos[0].importe;
          console.log('new top egreso max ', this.top_egresos_max);
        }

        if (this.top_ingresos.length <= 0 && this.top_egresos.length <= 0 && this.movimientos.length <=0) {
          this.loading_report = false;
          this.show_report = false;
          this.not_report = true;
        } else {
          this.loading_report = false;
          this.show_report = true;
          this.not_report = false;
        }
      }, error => {
        // resuelve errores 403, 500 y sin conexión.
        this.helpersService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
      });
  }

  getPercent(aportacion, maxAportacion){
    let operacion = (parseFloat(aportacion) * 100);
    let resultado = (operacion / parseFloat(maxAportacion));
    return resultado;
  }

  changeFilterConcepto(concepto) {
    console.log('changing concepto by ', concepto);
    this.concepto_filter = concepto;
    this.getReporte();
  }

  changeFilterFechaInicial(fecha) {
    this.fecha_inicial_filter = fecha;
    setTimeout(() => {
      this.getReporte();
    }, 200);
  }

  changeFilterFechaFinal(fecha) {
    this.fecha_final_filter = fecha;
    setTimeout(() => {
      this.getReporte();
    }, 200);
  }

  // SEGURITY MODULE
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.getReporte();
            this.securityActived = false;
            this.securityModal.push({
            'passwordActivated': false
          });
          }
        });
    }
  
  }

  canSecurity() {
    return this.reportesService.canSecurity();
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.reportesService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if(respuesta.success === true) {
          this.getReporte();
          this.securityModal.push({
            'passwordActivated': true
          });
          this.securityModal.close();
          this.securityActived = true;
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({
          'passwordActivated': false
        });
      })
  }

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      console.log('end to print');
      this.printing = false;
    };
  }

  openModalConcepto(idConceptos) {
    this.detallesKRModal.open({
      'idConceptos': idConceptos,
      'fechaInicial': this.fecha_inicial_filter,
      'fechaFinal': this.fecha_final_filter
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-balance-kr/reporte-balance-kr.component.ts